export default __webpack_public_path__ + "static/media/Maxvit-D-20000-ban.f4481483.jpg";